module.exports = __webpack_public_path__ + "images/emoji/cherry_blossom.bb967500a87e153db454.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cherry_blossom.png
// module id = F0Er
// module chunks = 13